module.exports = __webpack_public_path__ + "static/img/collectionpages.35b462a2.svg";